import React from "react";
import PostDetails from "../components/Posts/Details";

const BlogDetails = () => {
  return <PostDetails />;
};

export default BlogDetails;
